import bundledTsConfig from './ts-config.json';

/** Bundled defaults only — customer credentials load at runtime from ts-config.json. */
export const buildTsConfig = () => ({ ...bundledTsConfig });
